/**
 * Envelope parameters that live on the voice itself (not the FX bus).
 */
export type EnvelopeParam = 'decay'

/** Default 0..1 UI value for decay — roughly matches the v1.0.0 feel. */
export const DEFAULT_DECAY = 0.3

const MIN_SECONDS = 0.05
const MAX_SECONDS = 2.0

/**
 * Map a 0..1 UI dial value to seconds of release time. Quadratic so the lower
 * half of the dial stays "punchy" and the upper half reaches for longer tails.
 */
export function decaySeconds(value01: number): number {
  const v = Math.max(0, Math.min(1, value01))
  return MIN_SECONDS + (MAX_SECONDS - MIN_SECONDS) * v * v
}
